export const posts = [
  {
    slug: 'arquitetura-saas-multi-tenant-nestjs',
    title: 'Arquitetura SaaS Multi-tenant com NestJS + Prisma',
    excerpt: 'Como estruturar isolamento por empresa, autenticação JWT e governança de dados sem dor de cabeça.',
    date: '2025-08-10',
    tags: ['NestJS', 'Prisma', 'RBAC'],
    content: `
## Visão geral
Organize seu SaaS com camadas bem definidas (Domain, Service, Infra) e aplique filtros por empresa em todos os endpoints críticos.

### Pontos-chave
- Autenticação JWT + Role por empresa
- Filtro por empresaId em services e repositories
- Observabilidade e logs por tenant
`
  },
  {
    slug: 'open-finance-integradora',
    title: 'Open Finance na prática: pipeline integrador e UX segura',
    excerpt: 'Estratégias para integrar contas, extratos e consentimentos com foco em segurança e experiência.',
    date: '2025-08-15',
    tags: ['Open Finance', 'Segurança', 'UX'],
    content: `
## Fundamentos
Trate consentimento como recurso primeiro. Versione webhooks, valide assinaturas e normalize bancos.

### Checklist
- Gestão de consentimento centralizado
- Normalização de dados transacionais
- Alertas e reconciliação automática
`
  },
  {
    slug: 'cozinha-qr-impressora',
    title: 'Cozinha com QR Code + impressão térmica: fluxo robusto',
    excerpt: 'Do QR Code ao preparo, sem travar: filas de impressão, retries e confirmação por item.',
    date: '2025-08-05',
    tags: ['PDV', 'Impressão', 'Fluxo'],
    content: `
## Fluxo
Use um serviço de impressão isolado, filas (ex: Redis) e idempotência para pedidos e tickets.

### Dicas
- Persistir status por item
- Timeouts e reimpressão segura
`
  }
]
